/**
 * Single `exam` RBAC module — any of these grants access to Exams + Exam Management menus/routes.
 * Action buttons (create, mark, delete) remain gated by specific slugs in each page.
 */
/** Staff exam menus/routes (Exams + Exam Management share this list). */
export const EXAM_MODULE_PERMISSIONS = [
  "exam.read",
  "exam.create",
  "exam.update",
  "exam.delete",
  "exam.mark_score",
  "exam.report.download",
];

/** Student-facing results (separate route). */
export const EXAM_RESULT_VIEW_PERMISSIONS = ["exam.result.view", "exam.read"];
